import { render, staticRenderFns } from "./UpdatesOrdered.vue?vue&type=template&id=a9a8faa2&scoped=true&"
import script from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
export * from "./UpdatesOrdered.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesOrdered.vue?vue&type=style&index=0&id=a9a8faa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a8faa2",
  null
  
)

export default component.exports